<script setup lang="ts">
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';
import DraggableFormList from '@/core/components/form-elements/DraggableFormList.vue';
import { CarouselImage } from '@/modules/content-blocks/interfaces/carousel.interface';
import { createDefaultImage } from '@/modules/content-blocks/helpers/carousel.helper';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();

const addImage = (data: { slides: CarouselImage[] }) => {
   data.slides.push(createDefaultImage());
};

const removeImage = (data: { slides: CarouselImage[] }, id: string) => {
   const idx = data.slides.findIndex((i: CarouselImage) => i.id === id);
   if (idx !== -1) {
      data.slides.splice(idx, 1);
   }
};
</script>

<template>
   <DraggableFormList
      v-model="model.slides"
      :add-button-label="$t('live-editor.content-blocks.carousel.add-image')"
      @add="addImage(model as { slides: CarouselImage[] })"
      @remove="removeImage(model as { slides: CarouselImage[] }, $event)"
   >
      <template #title="{ index }">
         <h4>{{ $t('live-editor.content-blocks.carousel.image') + ' ' + (index + 1) }}</h4>
      </template>
      <template #fields="{ item: slide, index }">
         <div>
            <MediaSelector v-model="slide.image.url" v-model:media-id="slide.image_id" :error="errors[`slides[${index}].image_id`]" />
         </div>
      </template>
   </DraggableFormList>
</template>
